import localEtablissements from '../data/etablissements.json';

export class EtablissementsDataError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'EtablissementsDataError';
    this.code = code;
  }
}

export const asArray = (payload, keys = []) => {
  if (Array.isArray(payload)) return payload;
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
};

export const getEtablissementTypeFromCodstat = (codstat) => {
  if (Number(codstat) === 1) return 'Public';
  if (Number(codstat) === 2) return 'Privé';

  const normalized = String(codstat || '').trim();
  if (normalized === 'Public' || normalized === 'Privé') return normalized;

  return '';
};

export const normalizeEtablissement = (etablissement) => {
  const sigle = String(etablissement?.sigle_etab || etablissement?.sigle || etablissement?.code || '').trim();
  const denomination = String(
    etablissement?.denom_etabl ||
    etablissement?.nom_etablissement ||
    etablissement?.name ||
    ''
  ).trim();
  const typeEtablissement = (
    etablissement?.type_etablissement ||
    etablissement?.type_etablissment ||
    getEtablissementTypeFromCodstat(etablissement?.codstat || etablissement?.statut)
  );

  if (!denomination) return null;

  return {
    id: etablissement?.id,
    sigle_etab: sigle,
    denom_etabl: denomination,
    code: sigle,
    name: denomination,
    type_etablissement: typeEtablissement,
    type_etablissment: typeEtablissement,
  };
};

export const findEtablissementByValue = (etablissements, value) => {
  const normalizedValue = String(value || '').trim();
  if (!normalizedValue) return null;

  return etablissements.find((etablissement) => (
    etablissement.denom_etabl === normalizedValue ||
    etablissement.sigle_etab === normalizedValue
  )) || null;
};

export const buildUniversityOption = (uni) => {
  const sigle = uni.sigle_etab || uni.code;
  const denomination = uni.denom_etabl || uni.name;

  return {
    value: denomination,
    label: sigle ? `${denomination} | ${sigle}` : denomination,
    sigle,
    type_etablissement: uni.type_etablissement || uni.type_etablissment || '',
  };
};

export const getEtablissementsErrorMessage = (error) => {
  if (error?.name !== 'EtablissementsDataError') {
    return "Impossible de charger la liste locale des établissements.";
  }

  if (error.code === 'empty') {
    return "Aucun établissement n'est disponible dans src/data/etablissements.json.";
  }

  return error.message || "Impossible de charger la liste locale des établissements.";
};

export const fetchAllEtablissements = async () => {
  const etablissements = asArray(localEtablissements, ['data', 'etablissements']);

  if (!etablissements.length) {
    throw new EtablissementsDataError('empty', 'Aucun établissement disponible.');
  }

  return etablissements;
};
